<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Paparan Ternakan" >
      <w-card bg-color="" class="">
        
          
        <div class="w-flex wrap smd-column" >
          <div class="grow ">
            <div class="fw-normal my1 fs-1"><b>No Premis :</b><br>{{data.no_premis}}&nbsp;</div>
            <div class="fw-normal my1 fs-1"><b>Al Man :</b><br>{{data.user}}&nbsp;</div>
            <div class="fw-normal my1 fs-1"><b>Tarikh Mohon:</b><br>{{data.tarikh_mohon}}&nbsp;</div>
            <div class="fw-normal my1 fs-1"><b>Tarikh Check In:</b><br>{{data.tarikh}}&nbsp;</div>
          </div>
          <div class="mx2"></div>
          <div class="grow ">
            <div class="fw-normal my1 fs-1"><b>Tajuk :</b><br>{{data.tajuk}}&nbsp;</div>
            <div class="fw-normal my1 fs-1"><b>Keterangan :</b><br>{{data.keterangan}}&nbsp;</div>
            <div class="fw-normal my1 fs-1"><b>Status :</b><br>{{data.lkp_status}}&nbsp;</div>
          </div>
        </div>
        
         <div class="w-table-wrap" style="max-height: 400px;">
          <table class="w-table" color="light" >
            <thead>
              <tr>
                <th class="w-table__header  text-left" width="1%">No</th>
                <th class="w-table__header  text-left">Ternakan</th>
                <th class="w-table__header  text-left">Baka</th>
                <th class="w-table__header  text-left">Jantina</th>
                <th class="w-table__header  text-left">Pemeriksaan</th>
                <th class="w-table__header  text-left">AI Man</th>
                <th class="w-table__header  text-left">Status</th>
                <th class="w-table__header  text-left">Keterangan</th>
                <th class="w-table__header  text-left">Tindakan</th>
              </tr>
            </thead>

            <tbody>
              <template v-if="datas.length == 0">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
                </tr>
              </template>
              <template v-for="(dt, ind) in datas">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" >{{ind+1}}</td>
                  <td class="w-table__cell text-left" ><inertia-link :href="$route('ternakan.show',dt.ternakan_id)" >{{dt.ternakan}}</inertia-link></td>
                  <td class="w-table__cell text-left" >{{dt.baka}}</td>
                  <td class="w-table__cell text-left" >{{dt.jantina}}</td>
                  <td class="w-table__cell text-left" >{{dt.lkp_pemeriksaan}}</td>
                  <td class="w-table__cell text-left" >{{dt.user}}</td>
                  <td class="w-table__cell text-left" >{{dt.lkp_status}}</td>
                  <td class="w-table__cell text-left" >{{dt.keterangan}}</td>
                  <td>
                    <w-button dark class="green--bg ml1" @click="tindakan(dt)" v-if=" $zutil.role('Al Man') && dt.lkp_status_id == 16">
                       <w-icon class="mr1">fal fa-pencil</w-icon> Tindakan
                   </w-button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </w-card>
    </z-page>
      <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
      <template #title>
        <w-icon class="mr2">fal fa-cog</w-icon>
        Tindakan Check-In Al Man
      </template>
      <w-form  ref="form"  v-model="dialog.valid" @validate="submit" @success="success" >
        <w-textarea label="Keterangan"  v-model="form.keterangan" :validators="[validators.required]" />
      </w-form>
      <template #actions>
        <div class="spacer" />
        
        <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
        <template v-if="form.lkp_pemeriksaan_id == 1">
          <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()">Diperiksa </w-button>
        </template>
        <template v-if="form.lkp_pemeriksaan_id == 2">
          <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()">Diperiksa Tanpa Insemination</w-button>&nbsp;
          <inertia-link :href="$route('ternakan.show',form.ternakan_id)+'?insemination=1'" class="w-button w-button--dark size--md info-dark1--bg"> 
            <w-icon xs class="mr2">fal fa-eye</w-icon>  Insemination
          </inertia-link>
        </template>
        <template v-if="form.lkp_pemeriksaan_id == 3">
          <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()">Diperiksa Tanpa Vaksin</w-button>&nbsp;
          <inertia-link :href="$route('ternakan.show',form.ternakan_id)+'?vaksin=1'" class="w-button w-button--dark size--md info-dark1--bg"> 
            <w-icon xs class="mr2">fal fa-eye</w-icon>  Vaksin
          </inertia-link>
        </template>
      </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: this.api_service + "premis",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Ckeck In Premis', route: '/pemeriksaan' },
        { label: 'Papar', route: '/pemeriksaan/'+this.id },
      ],
      data : {id : 0},
      datas : [],
      form : {lkp_pemeriksaan_id : 0},
      attahecment : [],
      slides : [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      validators: {
        required: value => !!value || 'Wajib Isi.',
        
      }, 
    }
  },
  methods: {
    tindakan(dt){
      this.dialog.show = true
      this.form = dt
    },
    getData()
    {
      this.$zcomm.get(this.api_service + 'premis/pemeriksaan_show/'+this.id, {}).then(res => {
        this.data = res
        
      })
      this.$zcomm.get(this.api_service + 'premis/pemeriksaan_butiran/'+this.id, {}).then(res => {
        this.datas = res
      })
    },

    submit() {
      if(this.form.keterangan){
        this.form.pemeriksaan_id = this.data.id
        this.$zcomm.add( 'pemeriksaan.butiran', this.form)
        .then(res => {
          
          this.dialog.show = false;
          this.getData()
        })
        .finally(() => {
            this.dialog.loading = false;

        });
      }
    },
   

  },
  watch: {

  },
  mounted() {
    this.getData();
    
  },
}
</script>
